/**
 * Compatibility New-Check page — the session-less Y-site matrix, served at
 * /sessions/new. The matrix itself is a build-time snapshot, so the board is
 * fully usable with no session, and the check creates none.
 */

import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ChevronLeft } from 'lucide-react'
import { ReturnToMainAgent } from '@frontend/components/ReturnToMainAgent'
import { CompatibilityBoardConnected } from '../components/compatibility/CompatibilityBoardConnected'

export default function CompatibilityNewCheck() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className="flex flex-col h-dvh bg-neutral-50">
      <header className="flex items-center gap-2 px-4 py-3 pt-[max(0.75rem,env(safe-area-inset-top))] border-b border-neutral-200 bg-white">
        <ReturnToMainAgent className="-ml-2" />
        <button
          type="button"
          onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))}
          aria-label={t('common.back', 'Back')}
          className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full text-neutral-600 transition active:scale-95 hover:bg-neutral-100"
        >
          <ChevronLeft className="h-5 w-5" />
        </button>
        <h1 className="min-w-0 flex-1 truncate text-base font-semibold text-neutral-900">
          {t('compatibility.newCheck', 'New check')}
        </h1>
      </header>

      <main className="flex-1 overflow-auto">
        <CompatibilityBoardConnected />
      </main>
    </div>
  )
}
